import { connect } from 'react-redux'
import { getApper, saveJiaBanMeals,getuser } from './actions'
import Setting from './main'


const mapDispatchToProps = {
  getApper,
    saveJiaBanMeals,
    getuser
}
const mapStateToProps = (state) => {
  return {
    ...state.JiaBanMealsEditor
  }
}
  

export default connect(mapStateToProps, mapDispatchToProps)(Setting)
